<template>
  <v-row>
    <v-col cols="12" class="pb-0">
      <div class="mt-2">
        <div class="d-flex justify-space-between">
          <h3>Attachments ({{ attachments.length }})</h3>
          <v-avatar size="30"> <v-icon @click="clickUploader">mdi-camera-plus</v-icon></v-avatar>
        </div>
        <div class="d-flex justify-space-around flex-wrap">
          <div v-for="attachment in attachments" :key="attachment.id">
            <v-hover v-slot="{ hover }">
              <v-card class=" my-2 fake-link card-container" tile>
                <v-img
                  :src="attachment.file"
                  contain
                  class="attachment"
                  aspect-ratio="1"
                  @click="download(attachment.file, `${attachment.id}-task-attachment`)"
                />
                <v-fade-transition>
                  <v-overlay v-if="hover" absolute>
                    <v-btn
                      icon
                      small
                      class="mx-2"
                      @click="download(attachment.file, `${attachment.id}-task-attachment`)"
                    >
                      <v-icon> mdi-cloud-download</v-icon>
                    </v-btn>
                    <v-btn icon small class="mx-2" @click="removeImg(attachment.id)">
                      <v-icon> mdi-trash-can</v-icon>
                    </v-btn>
                  </v-overlay>
                </v-fade-transition>
              </v-card>
            </v-hover>
          </div>
        </div>

        <v-btn medium icon class="pointer">
          <div class="text-left pointer">
            <image-uploader
              id="#task-image-uploader"
              :maxWidth="800"
              hidden
              :preview="false"
              :quality="0.9"
              outputFormat="verbose"
              accept="image/*"
              @input="selectImg($event)"
            >
            </image-uploader>
          </div>
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { UPSERT_TASK_EVENT_MUTATION, DELETE_TASK_ATTACHMENT_MUTATION } from "@/graphql/mutations/task";
import { decodeId } from "@/lib/string";
import { getUserName } from "@/lib/username";
import FileDownloadMixin from "@/components/shared/mixins/FileDownloadMixin";
import ImageUploader from "vue-image-upload-resize";
import { dataURLtoBlob, blobToFile } from "@/lib/file";

export default {
  name: "TaskAttachment",
  props: {
    taskId: {
      type: String,
      required: true,
    },
    attachments: {
      type: Array,
      required: true,
    },
  },
  components: {
    ImageUploader,
  },
  mixins: [FileDownloadMixin],
  data() {
    return {
      files: [],
      showModal: null,
      saving: false,
    };
  },
  methods: {
    async selectImg(data) {
      this.errorMessage = null;
      const blob = dataURLtoBlob(data.dataUrl);
      const file = blobToFile(blob);

      this.$apollo
        .mutate({
          mutation: UPSERT_TASK_EVENT_MUTATION,
          variables: {
            taskEventId: decodeId(this.taskId),
            data: {
              files: [file],
            },
          },
          refetchQueries: ["taskEventsQuery"],
        })
        .then((result) => {
          if (!result.data.upsertTaskEvent.updated) {
            alert(result.data.upsertTaskEvent.error);
          } else {
            this.$toasted.success("File uploaded", {
              icon: "arm-flex",
              duration: 2000,
              position: "bottom-center",
            });
          }
        });
    },
    async removeImg(id) {
      let confirmed = confirm("Are you sure you want to remove this image?");
      if (!confirmed) return;
      this.$apollo
        .mutate({
          mutation: DELETE_TASK_ATTACHMENT_MUTATION,
          variables: {
            id: id,
          },
          refetchQueries: ["taskEventsQuery"],
        })
        .then((result) => {
          if (!result.data.deleteTaskAttachment.success) {
            alert(result.data.upsertTaskEvent.error);
          } else {
            this.$toasted.success("File removed", {
              icon: "arm-flex",
              duration: 2000,
              position: "bottom-center",
            });
          }
        });
    },
    clickUploader() {
      this.errorMessage = null;
      document.getElementById("#task-image-uploader").click();
    },
  },
};
</script>

<style scoped>
.attachment {
  object-fit: contain;
}
.card-container {
  width: 156px;
  background-color: #f4f4f4;
}
</style>
